'use es6';

import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import LeadCostData from 'AdsUI/data/LeadCostData';
export default {
  fetchLeadCosts() {
    return dispatch => {
      wrapReduxAction(LeadCostData.fetch.bind(null), 'LEAD_COST_FETCH', {
        dispatch
      });
    };
  }

};